import CurrencyIcon from '@/components/ui/icons/currency-icon';
import { handlePriceByComma } from '@/helpers/common';
import { useTranslations } from 'next-intl';

const CartTitle = ({ total }) => {
  const t = useTranslations('');

  return (
    <div className='flex flex-col gap-3'>
      <div className='flex items-center justify-between max-lg:flex-wrap max-lg:items-start max-lg:gap-2'>
        <div className='flex flex-col gap-1 max-lg:*:text-sm'>
          {total < 350 && (
            <h3 className='flex items-center gap-1 text-xl font-semibold lg:text-xl'>
              {t('cart.spend_key')}
              <span className='text-primary-500 flex items-center gap-1 md:text-xl lg:text-2xl'>
                {handlePriceByComma(350 - total)}{' '}
                <CurrencyIcon className='size-5 max-sm:size-3 sm:size-3.5' />
              </span>
              {t('cart.for_free_shipping_key')}
            </h3>
          )}
          <h5 className='flex flex-wrap items-center gap-1'>
            <span>{t('cart.free_shipping_for_any_orders_above')}</span>
            <span className='text-primary-500 flex items-center gap-1 font-bold'>
              {handlePriceByComma(350)} <CurrencyIcon className='size-3.5' />
            </span>
          </h5>
        </div>
        {total && (
          <div className='flex items-center gap-2 max-sm:*:text-xs sm:*:text-[13px] lg:*:text-base'>
            <span>{t('common.total_key')} : </span>
            <span className='text-primary-500 flex items-center gap-1 font-bold'>
              {handlePriceByComma(total)}{' '}
              <CurrencyIcon className='max-sm:size-3 sm:size-3.5 lg:size-4' />
            </span>
          </div>
        )}
      </div>
      <div className='bg-border relative h-5 w-full rounded-full max-lg:h-2'>
        <span
          className='bg-primary absolute start-0 top-0 h-full rounded-full'
          style={{
            width:
              total < 350 ? `${100 - ((350 - total) / 350) * 100}%` : '100%',
          }}
        />
      </div>
    </div>
  );
};

export default CartTitle;
